// extracted by mini-css-extract-plugin
export default {"divider":"styles_divider__9VHsO","divider--horizontal":"styles_divider--horizontal__XdZ6K","divider--vertical":"styles_divider--vertical__0yVDx"};